import { VisualizacaoModo, visualizacaoModoPipeline } from '../../../../common/visualizacao-modo';

export class CampanhaVisualizacao {
    modo: number;

    constructor(modo: VisualizacaoModo = visualizacaoModoPipeline) {
        this.modo = modo.id;
    }
}
